import { Table, Empty } from "antd";
import { getTeamColumns } from "../commons/team.helpers";

function MembersTable({ members, loading, onRevoke, revokingId }) {
  const columns = getTeamColumns({ onRevoke, revokingId });

  return (
    <div className="rounded-2xl border border-border/50 bg-card overflow-hidden shadow-card">
      <Table
        rowKey="member_id"
        columns={columns}
        dataSource={members}
        loading={loading}
        size="small"
        scroll={{ x: 600 }}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No members yet. Add someone to help manage this account."
            />
          ),
        }}
      />
    </div>
  );
}

export default MembersTable;
